// src/redux/settingsPages/userData/userDataAPI.js
import apiClient from '../../authentication/utils/core/axios';

const UserDataAPI = {
  async fetchSettings() {
    // Expect an object with your toggle keys; fallback to empty
    const res = await apiClient.get('/settings/privacy');
    return res.data ?? {};
  },

  async updateSettings(patch) {
    const res = await apiClient.patch('/settings/privacy', patch);
    return res.data ?? patch;
  },

  async resetDefaults() {
    // Server should return the default settings. If not, frontend will hard-reset.
    const res = await apiClient.post('/settings/privacy/reset');
    return res.data ?? {};
  },

  async requestExport() {
    const res = await apiClient.post('/settings/privacy/export');
    // Return a job id / token if the backend provides one
    return res.data ?? { job_id: null, status: 'queued' };
  },

  async fetchUsage() {
    const res = await apiClient.get('/settings/privacy/usage');
    return res.data ?? {};
  },

  async deleteAccount() {
    const res = await apiClient.delete('/settings/privacy/account');
    return res.data ?? { scheduled: true };
  },
};

export default UserDataAPI;
